<script>
export default {
    name: 'ServicePlanFeatureElementsArray',
};
</script>

<script setup>
import { computed, toRef } from 'vue';
import i18n from '@/plugins/i18n.ts';
import { FIELD } from '@/components/payments/components/service-plan/components/features/constants';
import useFeature from '@/components/payments/components/service-plan/components/features/composables/use-feature';
import ServicePlanFeatureElementsValue from '@/components/payments/components/service-plan/components/features/components/elements/value';
import formatList from '@/utils/format-list.ts';

const props = defineProps({
    feature: {
        type:     Object,
        required: true,
    },
    map:     {
        type:     Object,
        required: true,
    },
    unit:    {
        type:     [String, Function],
        required: true,
    },
});

const { value } = useFeature(toRef(props, 'feature'));

const formatted = computed(() => {
    const list = value.value.map(item => `<b>${props.map[item]}</b>`);

    const unit = typeof props.unit === 'function' ? props.unit(list) : props.unit;

    if (list.length < 2) return i18n.t('payment.servicePlan.feature.elements.array.one', { list, unit });

    return i18n.t('payment.servicePlan.feature.elements.array.many', { list: formatList(list), unit });
});
</script>

<template>
    <service-plan-feature-elements-value
        :name="feature[FIELD.NAME]"
        :value="formatted"
    />
</template>
